import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, catchError, shareReplay } from 'rxjs/operators';
import { ApiResponse, ExecutionResponse, ExecutionResponseCamel } from '../../models/support/execution-response';
import { BaseService, BaseServiceSZ } from 'src/app/services/other/baseService';
import { MessageService } from 'src/app/services/message/message.service';
import { SharedService } from '../other/shared.service';
import { formValueDates } from 'src/app/shared/helpers';
import { CheckLicenseResponse } from 'src/app/dashboard/licenses/license.model';
import { environment } from 'src/environments/environment';



@Injectable({
  providedIn: 'root'
})
export class LicenseService extends BaseService {

  private licensesUrl  //= super.BaseUrl() + 'License';  // URL to web api
  private subscriptionCache: Observable<CheckLicenseResponse> | null = null;

  constructor(
    private http: HttpClient, private messageService: MessageService,
    private _BaseService: BaseServiceSZ
  ) {
    super();
    this.licensesUrl = environment.SubscriptionAPI + 'v1/erp/subs/licenses';

  }






  CheckCurrentSubscription(branchId: number): Observable<CheckLicenseResponse> {
    // If the subscription cache exists, return it
    if (this.subscriptionCache) {
      return this.subscriptionCache;
    }

    // Otherwise, make the actual API call and cache it
    this.subscriptionCache = this.http.get<CheckLicenseResponse>(this.licensesUrl + '/check/' + branchId, {
      headers: super.getHeaders().headers
    }).pipe(
      tap((res) => {
        this._BaseService.log('CheckCurrentSubscription');
        this._BaseService.ValidationResult(res);
      }),
      catchError(
        this._BaseService.handleError<CheckLicenseResponse>('CheckCurrentSubscription')
      ),
      shareReplay(1) // Cache the result for future subscribers
    );

    // Return the observable (either cached or the newly made request)
    return this.subscriptionCache;
  }





}
